var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "main" }, [
    _c("div", { staticClass: "welcome" }, [
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x grid-padding-x" }, [
          _c("div", { staticClass: "cell" }, [
            _c("h1", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("home.title", {
                      user: _vm.$store.getters.getUser.profile,
                    })
                  ) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.getGreeting) +
                  ",\n            " +
                  _vm._s(
                    _vm.$t("home.subtitle", {
                      user: _vm.$store.getters.getUser.profile,
                      // ,'account': $store.getters.getUser.account
                    })
                  ) +
                  "\n          "
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-container" }, [
      _c(
        "div",
        { staticClass: "grid-x align-center" },
        [
          _c("v-risk-upload-dialog", {
            attrs: {
              projectId: _vm.$route.params.project,
              method: _vm.upload.method,
              isVisible: _vm.upload.isVisible,
            },
            on: { onAction: _vm.onChangeUpload },
            model: {
              value: _vm.upload.media,
              callback: function ($$v) {
                _vm.$set(_vm.upload, "media", $$v)
              },
              expression: "upload.media",
            },
          }),
          _vm._v(" "),
          _vm.$store.getters.userIsAdmin
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell small-12 small-order-2 large-3 large-order-1",
                  },
                  [
                    _c("div", { staticClass: "quicklinks box" }, [
                      _c("div", { staticClass: "quicklinks__title" }, [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.$t("home.quicklinks.title"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "quicklinks__content" }, [
                        _c(
                          "ul",
                          { staticClass: "quicklinks__list" },
                          [
                            _vm._l(_vm.quickLinks1, function (item) {
                              return [
                                _vm.$store.getters.userHasPermission(
                                  item.permission
                                )
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "button gray",
                                            attrs: {
                                              to: item.route,
                                              title: item.title,
                                            },
                                          },
                                          [
                                            _c("span", { class: item.action }),
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(item.title) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "quicklinks box" }, [
                      _c("div", { staticClass: "quicklinks__title" }, [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.$t("home.quicklinks2.title"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "quicklinks__content" }, [
                        _c(
                          "ul",
                          { staticClass: "quicklinks__list" },
                          [
                            _vm._l(_vm.quickLinks2, function (item) {
                              return [
                                _vm.$store.getters.userHasPermission(
                                  item.permission
                                )
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "button gray",
                                            attrs: {
                                              to: item.route,
                                              title: item.title,
                                            },
                                          },
                                          [
                                            _c("span", { class: item.action }),
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(item.title) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            }),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm.$store.getters.userIsAdmin
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button gray",
                                          on: { click: _vm.onUploadObject },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("home.upload-risk"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.userHasPermission("project_create") &&
          !_vm.$store.getters.userIsAdmin
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell small-12 small-order-2 large-3 large-order-1",
                  },
                  [
                    _c("div", { staticClass: "quicklinks box" }, [
                      _c("div", { staticClass: "quicklinks__title" }, [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.$t("home.quicklinks.title"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "quicklinks__content" }, [
                        _c("ul", { staticClass: "quicklinks__list" }, [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "button gray",
                                  attrs: {
                                    to: {
                                      name: "customers-create-customer-project",
                                      params: {
                                        customer:
                                          _vm.$store.getters.getUser
                                            .customer_id,
                                      },
                                    },
                                    title: _vm.$t(
                                      "home.quicklinks.create_project"
                                    ),
                                  },
                                },
                                [
                                  _c("span", { staticClass: "add" }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("home.quicklinks.create_project")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cell medium-12 large-order-2 large-9" },
            [
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "cell medium-8" }, [
                  _c(
                    "div",
                    { staticClass: "box box--small" },
                    [
                      _c(
                        "form",
                        {
                          staticClass: "filter filter--search",
                          attrs: {
                            action: "",
                            method: "POST",
                            novalidation: "",
                          },
                        },
                        [
                          _c("div", { staticClass: "grid-x grid-margin-x" }, [
                            _c(
                              "div",
                              { staticClass: "cell medium-6" },
                              [
                                _vm.$store.getters.userIsAdmin
                                  ? [
                                      _vm.$store.getters.userHasPermission(
                                        "project_list"
                                      )
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "button",
                                              attrs: {
                                                to: { name: "projects" },
                                                title:
                                                  _vm.$t("home.projects.view"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("home.projects.view")
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "cell medium-3" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("v-datepicker", {
                                    staticClass:
                                      "form-control form-control--small form-control--date",
                                    attrs: {
                                      placeholder: _vm.$t("search.from"),
                                      format:
                                        _vm.$t("search.from") +
                                        " " +
                                        _vm.$helpers.dateFormat,
                                      disabledDates: {
                                        days: [6, 0],
                                        from: new Date(
                                          _vm.projectsTableFilter.till
                                        ),
                                      },
                                      clearButton: true,
                                      language: _vm.de,
                                      "monday-first": true,
                                    },
                                    on: {
                                      selected:
                                        _vm.onChangeProjectsTableFromDate,
                                    },
                                    model: {
                                      value: _vm.projectsTableFilter.from,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.projectsTableFilter,
                                          "from",
                                          $$v
                                        )
                                      },
                                      expression: "projectsTableFilter.from",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cell medium-3" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("v-datepicker", {
                                    staticClass:
                                      "form-control form-control--small form-control--date",
                                    attrs: {
                                      placeholder: _vm.$t("search.till"),
                                      format:
                                        _vm.$t("search.till") +
                                        " " +
                                        _vm.$helpers.dateFormat,
                                      disabledDates: {
                                        days: [6, 0],
                                        to: new Date(
                                          _vm.projectsTableFilter.from
                                        ),
                                      },
                                      clearButton: true,
                                      language: _vm.de,
                                      "monday-first": true,
                                    },
                                    on: {
                                      selected:
                                        _vm.onChangeProjectsTableTillDate,
                                    },
                                    model: {
                                      value: _vm.projectsTableFilter.till,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.projectsTableFilter,
                                          "till",
                                          $$v
                                        )
                                      },
                                      expression: "projectsTableFilter.till",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-table", {
                        attrs: {
                          isLoading: _vm.projectsTableLoading,
                          columns: _vm.projectsTableColumns,
                          items: _vm.projectsTableItems,
                          showShowAll: false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "deadline",
                              fn: function ({ row }) {
                                return [
                                  _c("span", { staticClass: "table-date" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            row.createdon.date,
                                            "DD"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            row.createdon.date,
                                            "MMM"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "company",
                              fn: function ({ row }) {
                                return [
                                  _c("span", { staticClass: "table-label" }, [
                                    _vm._v(_vm._s(row.location.company_name)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "table-description" },
                                    [_vm._v(_vm._s(row.address.region))]
                                  ),
                                  _vm._v(" "),
                                  row.earliest_start
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "table-description table-description--normal",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "form.project.earliest_start"
                                                )
                                              ) +
                                              ":\n                    " +
                                              _vm._s(
                                                _vm.$helpers.formatEarliestStartLabel(
                                                  row.earliest_start
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !row.earliest_start_comment &&
                                  row.requested_deadline
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "table-description table-description--normal",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "form.project.requested_deadline"
                                                )
                                              ) +
                                              ":\n                    " +
                                              _vm._s(row.requested_deadline) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "address",
                              fn: function ({ row }) {
                                return [
                                  _c("span", { staticClass: "table-label" }, [
                                    _vm._v(_vm._s(row.project_number)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "table-description" },
                                    [
                                      _vm._v(
                                        _vm._s(row.address.zipcode) +
                                          " " +
                                          _vm._s(row.address.city)
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "qm",
                              fn: function ({ row }) {
                                return [
                                  _c("span", { staticClass: "table-label" }, [
                                    _vm._v(
                                      _vm._s(_vm.$helpers.formatNumber(row.qm))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "table-description" },
                                    [_vm._v(_vm._s(_vm.$t("qm")))]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "update",
                              fn: function ({ row }) {
                                return _vm.$store.getters.userHasPermission(
                                  "project_update"
                                )
                                  ? [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "button button--action button--action--edit button--small",
                                          attrs: {
                                            to: {
                                              name: "customers-update-customer-project",
                                              params: {
                                                customer: row.customer_id,
                                                project: row.id,
                                              },
                                            },
                                            title: _vm.$t("update"),
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("update")))]
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("v-pagination", {
                        attrs: {
                          currentPage: _vm.projectsCurrentPage,
                          itemsPerPage: _vm.projectsItemsPerPage,
                          items: _vm.projectsTableItemsCount,
                        },
                        on: { pageClicked: _vm.onChangeProjectsTablePage },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell medium-4" }, [
                  _c(
                    "div",
                    { staticClass: "box box--special" },
                    [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.$t("home.notifications.title"))),
                      ]),
                      _vm._v(" "),
                      _c("v-notifications"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "box__actions" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "button",
                              attrs: {
                                to: { name: "notifications" },
                                title: _vm.$t("more"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("more")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.$store.getters.userIsAdmin
                ? [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c("div", { staticClass: "cell medium-12" }, [
                        _c("div", { staticClass: "progress-graphic box" }, [
                          _c(
                            "div",
                            { staticClass: "progress-graphic__title" },
                            [
                              _c("h2", [
                                _vm._v(_vm._s(_vm.$t("home.projects.title"))),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "progress-graphic__content" },
                            [
                              _c(
                                "div",
                                { staticClass: "progress-graphic__chart" },
                                [
                                  _c("canvas", {
                                    attrs: {
                                      id: "projects-chart",
                                      height: "260",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "progress-graphic__chart__label",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("home.projects.label")
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "data" }, [
                                _c("div", { staticClass: "data__numbers" }, [
                                  _c("div", { attrs: { "data-static": "" } }, [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-static-number":
                                            _vm.projectsGrapInformation
                                              .yesterday,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.projectsGrapInformation
                                              .yesterday
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("home.projects.yesterday")
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { attrs: { "data-static": "" } }, [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-static-number":
                                            _vm.projectsGrapInformation.week,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.projectsGrapInformation.week
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("home.projects.week"))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { attrs: { "data-static": "" } }, [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-static-number":
                                            _vm.projectsGrapInformation.month,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.projectsGrapInformation.month
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("home.projects.month"))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { attrs: { "data-static": "" } }, [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-static-number":
                                            _vm.projectsGrapInformation.total,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.projectsGrapInformation.total
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("home.projects.total"))
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }